export class MediaFormat {
  public static THUMBNAIL = 'thumbnail';
  public static ORIGINAL = 'original';
  public static OPTIMIZED = 'optimized';
  public static SAMPLE_DURATION = 'sampleDuration';
  public static LOW_QUALITY = 'lowQuality';
}
